var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row flex-align-center flex-justify-space-between width-100"},[_c('div',{staticClass:"map-connection-text"},[_vm._v(_vm._s(_vm.title))]),(_vm.allowChange)?_c('div',{staticClass:"link-text",on:{"click":function($event){return _vm.$emit('change-mapping')}}},[_vm._v("Change mapping")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }